import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57ec5df1")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", {
    style: { width: _ctx.width + 'px' }
  }, [
    _createVNode("div", {
      class: ["block shadow-sm md:text-base lg:text-base sm:text-sm sm:h-8 md:h-12 lg:h-12 left-auto flex input-wrapper cursor-pointer", _ctx.disabled ? 'disable' : 'cursor-pointer'],
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
      ref: "calendar"
    }, [
      _createVNode("input", {
        class: [_ctx.disabled ? 'disable' : '', "w-full outline-none"],
        placeholder: _ctx.placeholder,
        type: "text",
        value: _ctx.date,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeInput($event)))
      }, null, 42, ["placeholder", "value"]),
      _createVNode("img", {
        class: "mx-2 right-0 icon",
        src: _ctx.icon || _ctx.DatePickerIcon,
        alt: "",
        srcset: ""
      }, null, 8, ["src"])
    ], 2),
    _withDirectives(_createVNode("div", {
      class: "datepicker__calendar",
      style: { marginTop: `${_ctx.top}px`, marginLeft: `${_ctx.left}px` }
    }, [
      _createVNode(_component_Calendar, {
        date: _ctx.date,
        "onUpdate:date": _cache[3] || (_cache[3] = ($event: any) => (_ctx.date = $event)),
        isShowCalendar: _ctx.isShowCalendar,
        "onUpdate:isShowCalendar": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowCalendar = $event)),
        format: _ctx.format
      }, null, 8, ["date", "isShowCalendar", "format"])
    ], 4), [
      [_vShow, _ctx.isShowCalendar]
    ]),
    _withDirectives(_createVNode("div", {
      class: "fixed top-0 left-0 w-screen h-screen z-50",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowCalendar = false))
    }, null, 512), [
      [_vShow, _ctx.isShowCalendar]
    ])
  ], 4))
})